import Img from 'gatsby-image';
import styled, { css } from 'styled-components';

import UI from '#front-credpago';

import BgLines from '../../../images/cp-lines.png';
import globals from '../../globals';

const { containerMaxWidth } = globals;

export const Container = styled.div`
  width: 100%;
  max-width: calc(${containerMaxWidth} + 40px);
  margin: 0 auto;
  align-self: center;
  position: relative;
  display: flex;
`;

export const FullWidthWrapper = styled.section`
  display: flex;
  max-height: 100%;
  height: 100vh;
  background: url(${BgLines}) no-repeat center center;
  background-size: auto 100%;
  position: relative;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    height: 100vh;
  }
`;

export const WrapperCards = styled.div`
  margin: 30px;
`;

export const Card = styled.div`
  background: #fff;
  max-width: 340px;
  min-width: 340px;
  margin: 10px auto;
  border-radius: 35px;
  box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.4);
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    max-width: 200px;
    min-width: 200px;
    min-height: 460px;
  }

  @media ${UI.globals.mediaqueries.md} {
    max-width: 230px;
    min-width: 230px;
    min-height: 460px;
    margin: 5px auto;
  }

  @media ${UI.globals.mediaqueries.lg} {
    max-width: 300px;
    min-width: 300px;
    min-height: 460px;
    margin: 5px auto;
  }
`;

export const WrapperContent = styled.div`
  min-height: 100px;
  text-align: center;
`;

export const WrapperImg = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const imageModifiers = {
  modelOne: () => css`
    width: 26%;
    margin-left: 20px;

    @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
      width: 33%;
    }
  `,

  modelTwo: () => css`
    width: 55%;
    margin-left: 60px;

    @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
      width: 100%;
    }
  `,
};

export const Image = styled(Img)`
  ${({ model }) => css`
    width: 55%;
    margin-bottom: 20px;

    @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
      width: 75%;
    }

    ${model === 1 && imageModifiers.modelOne()}
    ${model === 2 && imageModifiers.modelTwo()}
  `}
`;
